import { render, staticRenderFns } from "./BuddhistNotes.vue?vue&type=template&id=4048dc76&scoped=true"
import script from "./BuddhistNotes.vue?vue&type=script&lang=js"
export * from "./BuddhistNotes.vue?vue&type=script&lang=js"
import style0 from "./BuddhistNotes.vue?vue&type=style&index=0&id=4048dc76&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4048dc76",
  null
  
)

export default component.exports